import React, { useState, useEffect, useRef, useCallback } from "react";
import GradeAcademy from "./GradeAcademy.js";
import { v4 as uuidv4 } from 'uuid';
import getGradeValue from './getGradeValue.js';
import GeneralizedModal from "./GeneralizedModal.jsx";
import { is } from "@babel/types";
export default function GradeAcademyProcess({setIsLoading, profileModalOpen, openProfileModal, closeProfileModal, academyData, data, filterData, enrollment, setFileUploadVisible, dataSectionToRender, isModalOpen, setIsModalOpen, selectedStudentIdRef}) {
    const [lineData, setStudentData] = useState([]);
    const [courseData, setCourseData] = useState([]);
    const [subjectData, setSubjectData] = useState([]);
    const [nodeData, setNodeData] = useState([]);
    const [featureVectors, setFeatureVectors] = useState({});
    const [dataProcessed, setDataProcessed] = useState(false);
    const studentProfile = useRef([])
    const modalOpen = useRef();
    
    // console.log(filterData);
    const toggleModal = useCallback(() => {
        if (modalOpen.current) {
            console.log("Opening Modal");
            setIsModalOpen(true);
        } else {
            console.log("Closing Modal");
            setIsModalOpen(false);
        }
    }, [setIsModalOpen]);

    const handleModalOpenChange = useCallback((open) => {
        modalOpen.current = open;
        toggleModal();
    }, [toggleModal]);

    function getSum(array) {
        return array.reduce(function(a, b) { return a + b; }, 0)
    }
    function average(nums) {
        return nums.reduce((a, b) => a + b) / nums.length;
    }
    function getGPA(gradeValuesArray, unitsArray) {
        if (!Array.isArray(gradeValuesArray) || !Array.isArray(unitsArray)) return null;
      
        let totalQualityPoints = 0;
        let totalUnits = 0;
      
        const len = Math.min(gradeValuesArray.length, unitsArray.length);
        for (let i = 0; i < len; i++) {
          const gradeVal = Number(gradeValuesArray[i]);
          const units = Number(unitsArray[i]);
      
          if (Number.isFinite(gradeVal) && Number.isFinite(units) && units > 0) {
            totalQualityPoints += gradeVal * units; // multiply each course grade by its units
            totalUnits += units;
          }
        }
      
        return totalUnits > 0 ? totalQualityPoints / totalUnits : null;
    }
    

    function getQualityPoints(gradeValue, units) {
        return gradeValue*units;
    }

    useEffect(() => {
        function handleAddStudentData(newData) {
            setStudentData(prevLineData => {
                return [...prevLineData, newData]
            })
            
        }

        function handleAddCourseData(newData) {
            setCourseData(prevCourseData => {
                return [...prevCourseData, newData]
            })
            
        }
        function handleAddSubjectData(newData) {
            setSubjectData(prevSubjectData => {
                return [...prevSubjectData, newData]
            })
            
        }

        function handleAddNodeData(newData) {
            setNodeData(prevCourseData => {
                return [...prevCourseData, newData]
            })
            
        }

        var studentProcessedData = [];
        var courseProcessedData = [];
        var subjectProcessedData = [];
        var filterEmpty = true;
        var filterIDs = [];
        try {
            filterData.forEach((filter) => {
                // console.log(filter);
                filterIDs.push(filter.ID);
            });
        } catch(e) {
            // console.log(e);
        }
        // console.log(filterIDs);

        data.forEach((gradeData) => {
            if (filterData === []) {
                filterEmpty = true;
            } else {
                filterEmpty = false;
            }
            // if (filterEmpty || filterIDs.includes(gradeData.ID)) {
                var thisCourse = gradeData.SUBJECT_CODE + gradeData.COURSE_NUMBER;
                var qualityPoints = getQualityPoints(getGradeValue(gradeData.GRADE), gradeData.UNITS);
                if (!subjectProcessedData[gradeData.SUBJECT_CODE]) {
                    subjectProcessedData[gradeData.SUBJECT_CODE] = 1;
                } else {
                    subjectProcessedData[gradeData.SUBJECT_CODE] += 1;
                }
                if (!courseProcessedData[thisCourse]) {
                    courseProcessedData[thisCourse] = {};
                }
                if (!courseProcessedData[thisCourse]['grades']) {
                    courseProcessedData[thisCourse]['grades'] = {};
                    courseProcessedData[thisCourse]['grades'][gradeData.GRADE] = 0;
                }
                if (!courseProcessedData[thisCourse]['grades'][gradeData.GRADE]) {
                    courseProcessedData[thisCourse]['grades'][gradeData.GRADE] = {};
                    courseProcessedData[thisCourse]['grades'][gradeData.GRADE] = 1;
                } else {
                    courseProcessedData[thisCourse]['grades'][gradeData.GRADE] += 1;
                }
                if (!subjectProcessedData[gradeData.SUBJECT_CODE]) {
                    subjectProcessedData[gradeData.SUBJECT_CODE] = 1;
                } else {
                    subjectProcessedData[gradeData.SUBJECT_CODE] += 1;
                }
                // Log units.
                if (!courseProcessedData[thisCourse]['units']) {
                    courseProcessedData[thisCourse]['units'] = gradeData.UNITS;
                }
                // By term.
                if (!courseProcessedData[thisCourse]['term']) {
                    courseProcessedData[thisCourse]['term'] = {};
                }
                if (!courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]) {
                    courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE] = {};
                }
                if (!courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades']) {
                    courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades'] = {};
                }
                if (!courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades']) {
                    courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades'] = {};
                    courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades'][gradeData.GRADE] = 0;
                }
                if (!courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades'][gradeData.GRADE]) {
                    courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades'][gradeData.GRADE] = {};
                    courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades'][gradeData.GRADE] = 1;
                } else {
                    courseProcessedData[thisCourse]['term'][gradeData.TERM_CODE]['grades'][gradeData.GRADE] += 1;
                }
                
                if (!studentProcessedData[gradeData.ID]) {
                    studentProcessedData[gradeData.ID] = {};
                    studentProcessedData[gradeData.ID][gradeData.TERM_CODE] = {};
                    studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['grades'] = [];
                    studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['gradesActual'] = [];
                    studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['units'] = [];
                    studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['courses'] = [];
                    studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['subjectCodes'] = [];
                    studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['courseNumbers'] = [];
                    studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['qualityPoints'] = [];                
                } else {
                    if (!studentProcessedData[gradeData.ID][gradeData.TERM_CODE]) {
                        studentProcessedData[gradeData.ID][gradeData.TERM_CODE] = {};
                    }
                    if (!studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['grades']) {
                        studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['grades'] = [];
                    }
                    if (!studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['gradesActual']) {
                        studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['gradesActual'] = [];
                    }
                    if (!studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['units']) {
                        studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['units'] = [];
                    }
                    if (!studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['courses']) {
                        studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['courses'] = [];
                    }
                    if (!studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['subjectCodes']) {
                        studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['subjectCodes'] = [];
                    }
                    if (!studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['courseNumbers']) {
                        studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['courseNumbers'] = [];
                    }
                    if (!studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['qualityPoints']) {
                        studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['qualityPoints'] = [];
                    }

                }
                studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['grades'].push(getGradeValue(gradeData.GRADE));
                studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['gradesActual'].push(gradeData.GRADE);
                studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['units'].push(gradeData.UNITS);
                studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['courses'].push(thisCourse);
                studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['subjectCodes'].push(gradeData.SUBJECT_CODE);
                studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['courseNumbers'].push(gradeData.COURSE_NUMBER);
                studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['qualityPoints'].push(qualityPoints);
                studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['gpa'] = getGPA(studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['grades'], studentProcessedData[gradeData.ID][gradeData.TERM_CODE]['units']);
            // }

        })
        handleAddStudentData(studentProcessedData);
        handleAddCourseData(courseProcessedData);
        handleAddSubjectData(subjectProcessedData);

        // console.log(courseProcessedData);
        if (studentProcessedData.length > 0) {
            setDataProcessed(true);
            setFileUploadVisible(false);
        }
        // ===== Build subject universe =====
        const allSubjects = new Set();
        Object.values(studentProcessedData).forEach(terms => {
        Object.values(terms).forEach(term => {
            if (!term?.subjectCodes) return;
            term.subjectCodes.forEach(s => allSubjects.add(String(s)));
        });
        });
        const subjectList = Array.from(allSubjects); // fixed order
        const subjectIndex = new Map(subjectList.map((s,i)=>[s,i]));

        // ===== Feature vectors per student =====
        // Mode A: simple counts
        const featureVectors_counts = {}; // { studentId: number[] }
        Object.keys(studentProcessedData).forEach(studentId => {
        const v = new Array(subjectList.length).fill(0);
        Object.values(studentProcessedData[studentId]).forEach(term => {
            (term?.subjectCodes || []).forEach(subj => {
            const idx = subjectIndex.get(String(subj));
            if (idx != null) v[idx] += 1;
            });
        });
        featureVectors_counts[studentId] = v;
        });

        // Mode B: GPA-weighted subject profile (avg grade per subject)
        const featureVectors_gpaWeighted = {}; // { studentId: number[] }
        Object.keys(studentProcessedData).forEach(studentId => {
        const sum = new Array(subjectList.length).fill(0);
        const units = new Array(subjectList.length).fill(0);

        Object.values(studentProcessedData[studentId]).forEach(term => {
            const subjects = term?.subjectCodes || [];
            const grades   = term?.grades || [];   // numeric (your code already uses getGradeValue)
            const termUnits= term?.units || [];
            for (let i = 0; i < subjects.length; i++) {
            const idx = subjectIndex.get(String(subjects[i]));
            if (idx == null) continue;
            const g = Number(grades[i]);
            const u = Number(termUnits[i]);
            if (Number.isFinite(g) && Number.isFinite(u) && u > 0) {
                sum[idx]   += g * u;   // quality points in this subject
                units[idx] += u;
            }
            }
        });

        const v = sum.map((qp, i) => units[i] > 0 ? qp / units[i] : 0); // per-subject GPA (0..4)
        featureVectors_gpaWeighted[studentId] = v;
        });

        // Pass ONE (or both) to the UI via props or attach on nodes later.
        // Example: add to your GradeAcademy props:
        setFeatureVectors({
            subjectList,
            counts: featureVectors_counts,
            gpaWeighted: featureVectors_gpaWeighted
        });
    }, [data, filterData, enrollment])

    return (
        <div>
            {dataProcessed && 
            <>
            <GradeAcademy
                key="GradeAcademy"
                // isModalOpen={isModalOpen}
                setIsLoading={setIsLoading}
                modalOpen={modalOpen}
                // setIsModalOpen={setIsModalOpen}
                profileModalOpen={profileModalOpen}
                openProfileModal={openProfileModal}
                closeProfileModal={closeProfileModal}
                handleModalOpenChange={handleModalOpenChange}
                dataSectionToRender={dataSectionToRender}
                enrollment={enrollment}
                filterData={filterData}
                courseData={courseData}
                processedData={lineData}
                subjectData={subjectData}
                academyData={academyData}
                // setAcademyData={setAcademyData}
                studentProfile={studentProfile}
                selectedStudentIdRef={selectedStudentIdRef}
                featureVectors={featureVectors}
            />
            
            </>}
        </div>
  )
}
